import React from 'react';
import { monthsSuggestions } from '../../utils/data/date';
import { NewAutocompleteInput } from './NewAutocompleteInput';

export function NewMonthInput(props) {
  return <NewAutocompleteInput {...props} suggestions={monthsSuggestions} />;
}
